export enum TRACK {
  LOGIN = 'Login',
  LOGOUT = 'Logout',
  REGISTER = 'Register',
  QUESTIONNAIRE_START = 'Questionnaire Started',
  QUESTIONNAIRE_EXIT = 'Questionnaire Exited',
  QUESTIONNAIRE_COMPLETE = 'Questionnaire Completed',
  QUESTIONNAIRE_VIEWED = 'Questionnaire Viewed',
  QUESTIONNAIRE_CONTINUE = 'Questionnaire Continued',
}

export enum GROUPNAME {
  PROGRAMS = 'programs',
  LANGUAGES = 'languages',
  ORGANIZATIONS = 'organizations',
}
